import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import FormType, { IFormType } from "../../../model/formconfiguration/FormType";
import FormTypeForm from "./FormTypeForm";

export interface State {}

export interface UpdateFormTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IFormType;
}

class UpdateFormTypeForm extends React.Component<
  UpdateFormTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;

    registerFormSubmitEventHandler(e => {
      e.preventDefault();

      let updateFormTypeData;

      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateFormTypeData = FormType(values);
          updateFormTypeData.code = rowData.code;
        }
      });
      return updateFormTypeData;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FormTypeForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
      ></FormTypeForm>
    );
  }
}

export default UpdateFormTypeForm;
